import Box from '@mui/material/Box';
import { buttonClasses } from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useId } from 'react';

import { Button } from '@/components/ui/Button';

import { ARRIVES_WITH_INVITATIONS } from './supporterLabels';

interface AwaitingInvitationsButtonProps {
  /** What the button will do once member invitations exist. */
  label: string;
  /** `<testId>-button` on the button, `<testId>-hint` on its reason. */
  testId: string;
}

/**
 * An invite button shown before member invitations exist (P7, PB6).
 *
 * Marked disabled rather than made so: a `disabled` button cannot take focus,
 * and the keyboard sweep must reach it (PB7). It wears the theme's disabled
 * look through MUI's own class, which also stops pointer events, so the
 * tooltip sits on a wrapper as `ReasonedButton`'s does. It has no action, so
 * pressing it does nothing; the reason is a tooltip and a note tied to the
 * button, so a screen reader that finds it hears why.
 */
export function AwaitingInvitationsButton({
  label,
  testId,
}: AwaitingInvitationsButtonProps) {
  const noteId = useId();
  return (
    <>
      <Tooltip title={ARRIVES_WITH_INVITATIONS} describeChild>
        <span>
          <Button
            aria-disabled="true"
            aria-describedby={noteId}
            className={buttonClasses.disabled}
            data-testid={`${testId}-button`}
          >
            {label}
          </Button>
        </span>
      </Tooltip>
      <Box component="span" id={noteId} hidden data-testid={`${testId}-hint`}>
        {ARRIVES_WITH_INVITATIONS}
      </Box>
    </>
  );
}
